const DEFAULT_DEVICES_SORT = {
  order: [{ by: 'id', order: 'asc' }],
};

export const FAULTY_CHART_SEGMENT_NAME = 'Nepasiekiamas';

export const buildDevicesPresetFromIds = deviceIds => {
  const ids = (deviceIds || [])
    .map(id => Number(id))
    .filter(id => !Number.isNaN(id));

  if (!ids.length) {
    return null;
  }

  return {
    filterBody: {
      ...DEFAULT_DEVICES_SORT,
      filter: {
        and: [{ field: 'id', value: ids }],
      },
    },
    idFilter: ids,
    sortOrder: 'asc',
  };
};
